// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__23rPq","head":"ProcedureTableInfo_head__1cidW"};